<template>
  <BCard class="text-black">
    <h4 class="font-bold text-black text-2xl">
      Komerce Balance
    </h4>
    <div class="d-flex justify-between mt-1 mb-3">
      <div class="align-self-center d-flex">
        <div class="k-calendar text-3xl mr-1" />
        <div class="align-self-center">
          {{ formattedToday }}
        </div>
      </div>
      <b-button
        variant="outline-secondary"
        :disabled="loadingDownload"
        @click="openInputBTM()"
      >
        <span class="text-black">
          Download
        </span>
      </b-button>
    </div>
    <div class="d-flex gap-20 mb-2">
      <Card
        title="Cash in Bank"
        redirect="/mutation-bank/detail"
        :loading="loadingBank"
        :balance="balanceInBank"
        :list="listCashInBank"
      />
      <Card
        title="Cash in Payment Gateway"
        :loading="loadingPG"
        :balance="balanceInPaymentGateway"
        :list="listCashInPaymentGateway"
      />
    </div>

    <!-- Modal BTM Input Manual -->
    <BModal
      id="modalBtmSaldoInput"
      centered
      title="Masukkan Nominal Saldo BTM Perkasa Purbalingga"
      ok-title="Simpan"
      cancel-title="Batal"
      title-class="text-black"
      hide-header-close
      :ok-disabled="saldoBTM === '' || saldoBTM === null || saldoBTM < 0 || saldoBTM > 999999999999"
      @ok="handleFinish"
    >
      <label class="text-black mb-1">Nominal Saldo</label>
      <BFormInput
        v-model.number="saldoBTM"
        type="number"
        placeholder="Masukkan nominal saldo..."
        min="0"
        max="999999999999"
        @keypress="isNumber"
        @keydown="handleKeyDown"
        @input="handleInputLimit"
      />
    </BModal>

    <!-- Komponen PDF Generator -->
    <DownloadMutation
      ref="pdfGenerator"
      :formatted-today="formattedToday"
      :balance-in-bank="balanceInBank"
      :list-cash-in-bank="listCashInBank"
      :balance-in-payment-gateway="balanceInPaymentGateway"
      :list-cash-in-payment-gateway="listCashInPaymentGateway"
      @loading="loadingDownload = $event"
    />
  </BCard>
</template>

<script>
import { newAxiosIns } from '@/libs/axios'
import moment from 'moment'
import { isNumber } from '@/libs/helpers'
import Card from './Card.vue'
import DownloadMutation from './DownloadMutation.vue'

export default {
  components: {
    Card,
    DownloadMutation,
  },
  data() {
    return {
      isNumber,
      loadingBank: false,
      loadingPG: false,
      loadingDownload: false,
      balanceInBank: 0,
      balanceInPaymentGateway: 0,
      listCashInBank: [],
      listCashInPaymentGateway: [],
      saldoBTM: null,
    }
  },
  computed: {
    formattedToday() {
      return moment().locale('en').format('ddd D MMM YYYY HH:mm')
    },
  },
  mounted() {
    this.handleFirstLoad()
  },
  methods: {
    handleFirstLoad() {
      this.getBankData()
      this.getPaymentGatewayData()
    },
    openInputBTM() {
      const isBtmExist = this.listCashInBank.some(a => a.account_number === 1010700232)
      if (isBtmExist) return this.downloadPdf()
      return this.$bvModal.show('modalBtmSaldoInput')
    },
    handleKeyDown(e) {
      const isControlKey = ['Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab', 'Enter'].includes(e.key) || e.ctrlKey || e.metaKey
      if (this.saldoBTM >= 999999999999 && !isControlKey) e.preventDefault()
    },
    handleInputLimit(val) {
      if (val > 999999999999) this.saldoBTM = 999999999999
      if (val < 0 && val !== '') {
        this.saldoBTM = 0
      }
    },
    handleFinish() {
      this.balanceInBank += this.saldoBTM
      this.listCashInBank.push(
        {
          id: '',
          name: 'BTM Perkasa Purbalingga',
          icon: 'https://storage.googleapis.com/komerce/Komship/BMP-logo.png',
          account_number: 1010700232,
          balance: this.saldoBTM,
        },
      )
      this.downloadPdf()
    },
    downloadPdf() {
      this.$refs.pdfGenerator.generate()
    },
    async getBankData() {
      this.loadingBank = true
      try {
        const [balance, list] = await Promise.all([
          newAxiosIns.get('/moota/api/v1/bank/total-balance'),
          newAxiosIns.get('/moota/api/v1/bank/accounts'),
        ])
        this.balanceInBank = balance.data.data.total_balance
        this.listCashInBank = list.data.data
      } catch (error) {
        this.$toast_error({
          message: error.response?.data?.meta?.message || 'Gagal memuat data Bank',
          timeout: 2000,
        })
      } finally {
        this.loadingBank = false
      }
    },
    async getPaymentGatewayData() {
      this.loadingPG = true
      try {
        const [balance, list] = await Promise.all([
          newAxiosIns.get('/moota/api/v1/payment-gateway/total-balance'),
          newAxiosIns.get('/moota/api/v1/payment-gateway/accounts'),
        ])
        this.balanceInPaymentGateway = balance.data.data.total_balance
        this.listCashInPaymentGateway = list.data.data
      } catch (error) {
        this.$toast_error({
          message: error.response?.data?.meta?.message || 'Gagal memuat data Payment Gateway',
          timeout: 2000,
        })
      } finally {
        this.loadingPG = false
      }
    },
  },
}
</script>
